import styled from "styled-components";
export const StyledCheckListPage = styled.div`
	.CheckListTable {
		/* overflow: hidden; */
		height: calc(100vh - 320px) !important;
	}
	.checkboxItem {
		min-width: 30px;
	}
	.availabilityItem {
		min-width: 200px;
	}

	.titleControlBox {
		width: 100%;
		position: relative;
		display: flex;

		.flexStartBox {
			display: flex;
			justify-content: flex-start;
			padding: 10px 0;
		}

		.selectionBar {
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			flex-wrap: wrap;
			row-gap: 10px;

			> div {
				margin-right: 8px;
				width: 130px;
			}

			/* 寬度例外：在 Select / SearchSelect 加上對應 className 即可，不需為個別欄位新增樣式 */
			> div.w220 {
				width: 220px;
			}

			/* PickListDropdown 預設是深色底，這裡對齊旁邊 antd Select 的白底外觀與 32px 高度 */
			.checkStatusFilter {
				width: 170px;

				> div {
					width: 100%;
				}

				.header {
					box-sizing: border-box;
					align-items: center;
					height: 32px;
					padding: 0 11px;
					font-size: 14px;
					color: rgba(0, 0, 0, 0.85);
					background-color: #fff;
					border: 1px solid #d9d9d9;
					border-radius: 2px;
					transition: border-color 0.3s;

					&:hover {
						background-color: #fff;
						border-color: #40a9ff;
					}

					> .title {
						min-width: 0;
						overflow: hidden;
						white-space: nowrap;

						> span:first-child {
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}

					> .icon {
						margin-left: 4px;

						> div {
							color: rgba(0, 0, 0, 0.25);

							> * {
								font-size: 16px;
							}
						}
					}
				}
			}
		}
	}

	.buttonGroup {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 30px;

		.btn {
			margin-left: 8px;
		}
	}

	.countText {
		color: #fff;
		padding: 10px 0;
	}

	.loading {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;

export const UiPopupContainer = styled.div`
	.ant-tabs-tab-btn {
		display: flex;
		align-items: center;

		i {
			margin-right: 5px;
		}
	}

	.ant-image-preview-img-wrapper::before {
		height: 25%;
	}

	.ant-image-preview-img {
		margin: auto;
		width: 100%;
		max-width: 70vw;
	}
`;

export const StyledAvailability = styled.div`
	> p {
		display: flex;
		align-items: center;
	}
`;

export const UiLoadingBox = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.2);
	z-index: 2999;
`;
